import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import About from '../components/About/About';
import { type User } from '../services/graphql/authService';
import { ServiceConfig } from '../utils/serviceKeys';
import { trackPageView } from '../services/analytics';

interface AboutPageProps {
  currentUser: User | null;
  serviceConfig: ServiceConfig;
}

/**
 * AboutPage component that displays information about the service
 * including contact form and feedback options
 */
const AboutPage: React.FC<AboutPageProps> = ({ currentUser, serviceConfig }) => {
  const { serviceKey } = useParams<{ serviceKey: string }>();

  // Track page view when the page loads
  useEffect(() => {
    trackPageView(`/${serviceKey || serviceConfig.serviceId}/about`);
  }, [serviceKey, serviceConfig.serviceId]);

  return (
    <div className="container mx-auto px-4 py-8">
      <About serviceConfig={serviceConfig} currentUser={currentUser} />
    </div>
  );
};

export default AboutPage;
